import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconSharedLink = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 26"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M6.75 18.249l10.5-10.5M7.735 13.021a4.472 4.472 0 00-3.417 1.3l-2.25 2.25a4.5 4.5 0 106.364 6.364l2.25-2.25a4.472 4.472 0 001.3-3.417M16.265 12.976a4.473 4.473 0 003.417-1.3l2.25-2.25a4.5 4.5 0 00-6.364-6.364l-2.25 2.25a4.475 4.475 0 00-1.295 3.417",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M18.483 16.599a.696.696 0 001.034 0l.336-.37a.697.697 0 011.213.503l-.025.498a.696.696 0 00.73.731l.498-.025a.697.697 0 01.501 1.213l-.37.334a.697.697 0 000 1.035l.37.334a.697.697 0 01-.502 1.213l-.498-.025a.696.696 0 00-.732.731l.026.498a.697.697 0 01-1.21.502l-.335-.37a.697.697 0 00-1.035 0l-.336.37a.697.697 0 01-1.211-.501l.025-.498a.697.697 0 00-.731-.731l-.498.025a.696.696 0 01-.504-1.212l.37-.334a.697.697 0 000-1.035l-.37-.336a.696.696 0 01.501-1.212l.498.025a.696.696 0 00.732-.732l-.023-.499a.697.697 0 011.211-.501l.335.369z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M19 21.601a1.6 1.6 0 100-3.201 1.6 1.6 0 000 3.201z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconSharedLink.displayName = "IconSharedLink";

export { IconSharedLink };
